





import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Login from '../../Authentication/Login';

const PublicHeader = () => {
    const [modalStep, setModalStep] = useState(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false); 
    
    // --- NEW STATE FOR FLASH MESSAGES ---
    const [flash, setFlash] = useState({ message: '', type: '' });

    const navigate = useNavigate();
    const closeModal = () => setModalStep(null);

    // --- NEW FUNCTION TO SHOW FLASH ---
    const showFlash = (message, type = 'danger') => {
        setFlash({ message, type });
        setTimeout(() => setFlash({ message: '', type: '' }), 4000); // Auto-hide after 4 seconds
    };

    return (
        <>
            {/* --- FLASH MESSAGE UI --- */}
            {flash.message && (
                <div 
                    className={`alert alert-${flash.type} alert-dismissible fade show position-fixed start-50 translate-middle-x shadow-lg`} 
                    style={{ 
                        top: '100px', 
                        zIndex: 9999, 
                        minWidth: '320px', 
                        borderRadius: '12px',
                        fontWeight: '600',
                        border: 'none'
                    }} 
                    role="alert"
                >
                    <i className="ri-error-warning-line me-2"></i>
                    {flash.message}
                    <button type="button" className="btn-close" onClick={() => setFlash({ message: '', type: '' })}></button>
                </div>
            )}

            <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top py-2">
                <div className="container">
                    <Link className="navbar-brand d-flex align-items-center" to="/">
                        <svg width="52" height="52" viewBox="0 0 180 120" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '5px' }}>
                            <text x="0" y="90" fontFamily="Playfair Display, Didot, serif" fontSize="96" fontWeight="700" letterSpacing="-10" fill="#111">MF</text>
                        </svg>
                        <div className="d-flex flex-column">
                            <span style={{ fontSize: '1.05rem', fontWeight: '500', letterSpacing: '0.35rem', color: '#111', lineHeight: '1.1' }}>MUNNY FINDS</span>
                            <span style={{ fontSize: '0.55rem', letterSpacing: '0.25rem', fontWeight: '600', color: '#6b7280', marginTop: '2px' }}>BEAUTY & CARE</span>
                        </div>
                    </Link>

                    <button 
                        className="navbar-toggler shadow-none border-0" 
                        type="button" 
                        onClick={() => setIsMenuOpen(!isMenuOpen)} 
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
                        <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-lg-3 text-center">
                            <li className="nav-item">
                                <Link className="nav-link fw-semibold text-dark" to="/" onClick={() => setIsMenuOpen(false)}>Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link fw-semibold text-dark" to="/all-categories" onClick={() => setIsMenuOpen(false)}>Categories</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link fw-semibold text-dark" to="/products/search" onClick={() => setIsMenuOpen(false)}>Products</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/about-us" className="nav-link fw-semibold text-dark" onClick={() => setIsMenuOpen(false)}>About Us</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/contact" className="nav-link fw-semibold text-dark" onClick={() => setIsMenuOpen(false)}>Contact</Link>
                            </li>
                        </ul>
                        
                        <div className="d-flex flex-column flex-lg-row align-items-center gap-3">
                            <button 
                                onClick={() => { setModalStep('login'); setIsMenuOpen(false); }} 
                                className="btn btn-link text-decoration-none fw-bold text-white rounded-3 shadow-sm" 
                                style={{ backgroundColor: '#059669', fontSize: '0.95rem', width: '50%', padding: '8px 20px' }}
                            >
                                Login
                            </button>
                            
                            <button 
                                onClick={() => { navigate('/register-business'); setIsMenuOpen(false); }} 
                                className="btn btn-link text-decoration-none fw-bold text-white rounded-3 shadow-sm" 
                                style={{ backgroundColor: '#059669', fontSize: '0.95rem', width: '100%', padding: '8px 20px' }}
                            >
                                <i className="ri-building-4-line me-1"></i> Business
                            </button>
                        </div>
                    </div>
                </div>
            </nav>

            {modalStep === 'login' && (
                <Login 
                    closeModal={closeModal} 
                    switchToSignup={() => closeModal()} 
                    // Pass the flash trigger to Login component
                    onError={(msg) => showFlash(msg, 'danger')} 
                />
            )}
        </>
    );
};

export default PublicHeader;